<template>
    <el-dialog
        :title="'编辑信息项'"
        :visible.sync="infoDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        width="800px"
        center>
        <el-form
            :model="signupForm"
            :rules="rules"
            ref="signupForm"
            label-width="100px">
            <el-form-item label="表单类型" prop="type">
                <el-radio-group v-model="signupForm.type" @change="typeChange" :disabled="setIndex !== -1">
                    <el-radio :label="1">单行文本</el-radio>
                    <el-radio :label="2">多行文本</el-radio>
                    <el-radio :label="3">单选题</el-radio>
                    <el-radio :label="4">多选题</el-radio>
                    <el-radio :label="8">日期选择</el-radio>
                    <el-radio :label="6">图片上传</el-radio>
                    <el-radio :label="7">附件上传</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="标题" prop="title">
                <el-input v-model="signupForm.title" placeholder="请输入标题"></el-input>
            </el-form-item>
            <el-form-item label="数量限制" prop="limit"
                          v-if="Number(signupForm.type) === 6 || Number(signupForm.type) === 7"
            >
                <el-radio-group v-model="signupForm.limit">
                    <el-radio :label="0">单文件上传</el-radio>
                    <el-radio :label="1">多文件上传</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="状态" prop="isMust">
                <el-radio-group v-model="signupForm.isMust">
                    <el-radio :label="1">必填</el-radio>
                    <el-radio :label="0">非必填</el-radio>
                </el-radio-group>
            </el-form-item>
          <el-form-item label="会员是否可见" prop="isShow">
            <el-radio-group v-model="signupForm.isShow">
              <el-radio :label="1">可见</el-radio>
              <el-radio :label="0">不可见</el-radio>
            </el-radio-group>
          </el-form-item>
            <el-form-item label="格式验证" v-if="Number(signupForm.type) === 1">
                <el-radio-group v-model="signupForm.pattern">
                    <el-radio :label="0">不校验</el-radio>
                    <el-radio :label="1">手机号</el-radio>
                    <el-radio :label="2">数字</el-radio>
                    <el-radio :label="3">邮箱</el-radio>
                    <el-radio :label="4">网址</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="统计" v-if="Number(signupForm.pattern) === 2">
                <el-checkbox-group v-model="signupForm.total">
                    <el-checkbox :label="1">求和</el-checkbox>
                    <el-checkbox :label="2">求平均值</el-checkbox>
                </el-checkbox-group>
            </el-form-item>
            <el-form-item
                label="默认值"
                prop="options"
                v-if="Number(signupForm.type) === 3 || Number(signupForm.type) === 4"
            >
                <el-input
                    type="textarea"
                    v-model="signupForm.options"
                    placeholder="单选多选默认值格式:[ 男/女/未知 ] 选项用 / 分开 "
                ></el-input>
            </el-form-item>
            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('signupForm')">
                    取消
                </el-button>
                <el-button
                    class="padding-lr-xl"
                    type="primary"
                    @click="submitForm('signupForm')"
                >提交
                </el-button
                >
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>


export default {
    name: "infoDialog",
    props: {
        infoDialog: {
            type: Boolean,
            default: false
        },
        setIndex: {
            type: Number,
            default() {
                return -1;
            }
        },
        setItem: {
            type: Object
        }
    },
    data() {
        return {
            signupForm: {
                type: 1,
                title: '',
                field: '',
                limit: 0,
                isMust: 1,
              isShow: 1,
                pattern: 0,
                total: [],
                options: '',
            },
            rules: {
                type: [
                    {required: true, message: '请选择类型', trigger: 'change'},
                ],
                title: [
                    {required: true, message: '请输入标题', trigger: 'blur'},
                ],
                limit: [
                    {required: true, message: '请选择数量限制', trigger: 'change'},
                ],
                isMust: [
                    {required: true, message: '请选择状态', trigger: 'change'},
                ],
                options: [
                    {required: true, message: '请输入默认值', trigger: 'blur'},
                ],
            },
        }
    },
    created() {
    },
    methods: {
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', [false, ''])
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        typeChange(){
            this.signupForm.pattern = 0
            this.signupForm.total = []
        },
        submitData(formName) {
            let _options = []
            if (Number(this.signupForm.type) === 3 || Number(this.signupForm.type) === 4) {
                if (!this.signupForm.options) return this.$message.error('选择题需填写默认值')
                let _val = JSON.parse(JSON.stringify(this.signupForm.options))
                let _arr = _val.split('/')
                _arr.map((item, index) => {
                    _options.push({
                        value: index,
                        label: item
                    })
                })
            }

            let _answer = ''
            if (this.signupForm.type === 4 || this.signupForm.type === 6 || this.signupForm.type === 7) {
                _answer = []
            }
            let _rules = [{required: true, message: '请选择', trigger: 'change'}]
            if (this.signupForm.type === 1 || this.signupForm.type === 2) {
                _rules = [{required: true, message: '请输入', trigger: 'blur'}]
            }
            this.$emit("cancelDialog", [true, JSON.parse(JSON.stringify({
                type: this.signupForm.type,
                title: this.signupForm.title,
                isMust: this.signupForm.isMust ? true : false,
                isShow: this.signupForm.isShow ? true : false,
                field: this.signupForm.field || `${this.signupForm.title}${new Date().getTime()}`,
                pattern: this.signupForm.pattern,
                total: this.signupForm.total,
                options: _options,
                answer: _answer,
                isSet: true,
                limit: this.signupForm.limit,
                rules: this.signupForm.isMust ? _rules : []
            }))]);
            this.$refs[formName].resetFields();
        }

    },
    watch: {
        setItem() {
            let _str = ''
            if (this.setItem.options && this.setItem.options.length > 0) {
                let _arr = []
                this.setItem.options.map(item => {
                    _arr.push(item.label)
                })
                _str = _arr.join('/')
            }
            console.log(this.setItem.isShow)
            this.signupForm = {
                type: this.setItem.type ? this.setItem.type : 1,
                title: this.setItem.title,
                field: this.setItem.field ,
                pattern: this.setItem.pattern || 0,
                total: this.setItem.total || [],
                isMust: this.setIndex === -1 ? 1 : (this.setItem.isMust ? 1 : 0),
              isShow : this.setItem.isShow === undefined?1:(this.setItem.isShow ? 1 : 0),
                options: _str,
                limit: this.setItem.limit ? this.setItem.limit : 0,
            };
        }
    }
}
</script>

<style scoped lang="scss">
</style>
